// src/components/Ownerdashboard/OwnerProtectedRoute.jsx
import React, { useState } from "react";
import OwnerLogin from "./OwnerLogin";
import { isOwnerLoggedIn } from "./ownerAuth";

/**
 * Renders the owner login screen in place until the owner has a valid token,
 * so opening /owner/dashboard directly shows the login page without a redirect.
 */
const OwnerProtectedRoute = ({ element: Component }) => {
  const [loggedIn, setLoggedIn] = useState(() => isOwnerLoggedIn());

  if (!loggedIn) {
    return <OwnerLogin onSuccess={() => setLoggedIn(true)} />;
  }

  return <Component />;
};

export default OwnerProtectedRoute;
  